import CRUDService from './crud-service';

export default new CRUDService('/v1/time-sensitive-item-types');
